import {DataFetcher} from '@aboutyou/data-fetcher';
import React from 'react';
import {useComputeDefaultState} from '../PriceAndBrand/utils';
import {usePriceAndBrandSection} from '../useGetProductBulkSection';
import {PriceAndAddToBasketQuickViewLoading} from './PriceAndAddToBasketQuickViewLoading';
import {
  PriceAndAddToBasketQuickViewView,
  PriceAndAddToBasketQuickViewViewProps,
} from './PriceAndAddToBasketQuickViewView';

export const PriceAndAddToBasketQuickView: React.FC<
  PriceAndAddToBasketQuickViewViewProps
> = props => {
  const defaultState = useComputeDefaultState();

  return (
    <DataFetcher
      request={usePriceAndBrandSection()}
      Error={null}
      Loading={() => (
        <PriceAndAddToBasketQuickViewLoading className={props.className} />
      )}
      viewProps={props}
      View={PriceAndAddToBasketQuickViewView}
      computeDefaultState={() => defaultState}
    />
  );
};
